module.exports = __webpack_public_path__ + "img/8.5167da46.jpg";